<template>
  <div>
    <b-card bg-variant="Success" class="text-center" v-if="submitted">
        <b-button
        variant="outline-primary"
        :to="{ name: 'crm-utenti-index' }"
        >
            <feather-icon
                icon="CornerUpLeftIcon"
                size="16"
                class="mr-1"
            />Lista Utenti
        </b-button>
    </b-card>

    <b-card border-variant="danger" v-if="errore_caricamento">
      <b-row class="match-height">
        <b-col
          md="8"
        >
          <h4 class="mt-0 mb-0 text-danger">Errore durante il caricamento delle informazioni iniziali</h4>
          <p>Ti preghiamo di segnalare il problema all'assistenza tecnica, grazie</p>
        </b-col>
        <b-col 
          md="4"
          class="text-center"
        >
          <b-button
          variant="primary"
          :to="{ name: 'crm-leads-index' }"
          >
              <feather-icon
                  icon="CornerUpLeftIcon"
                  size="16"
                  class="mr-1"
              />Leads
          </b-button>
        </b-col>
      </b-row>
        
    </b-card>
    
    <div class="text-center my-3" v-if="Caricato == false">
        <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem;"
            class="mr-1"
            label="loading"
        />
    </div>

    <div v-if="Caricato">
      <validation-observer ref="simpleRules">
        <b-form>
              <b-tabs pills>
                <b-tab active>
                  <template #title>
                    <feather-icon
                      icon="UserIcon"
                      size="16"
                      class="mr-0 mr-lg-50"
                    />
                    <span class="d-none d-lg-inline">Dettagli</span>
                  </template>
                  <b-card bg-variant="Default">
                    <b-row>
                      <b-col md="4" lg="3">
                        <b-form-group label="Ragione Sociale *" label-for="company_name">
                          <validation-provider
                            #default="{ errors }"
                            name="Nome"
                            rules="required"
                            >  
                            <b-form-input
                              v-model="campiform.billing.company_name"
                              placeholder=""
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Nome *" label-for="name">
                            <validation-provider
                            #default="{ errors }"
                            name="Nome"
                            rules="required"
                            >
                            <b-form-input
                                v-model="campiform.lead.name"
                                :state="errors.length > 0 ? false:null"
                                placeholder="" 
                                @input="aggiornaRappresentante"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Cognome *" label-for="Surname">
                            <validation-provider
                            #default="{ errors }"
                            name="Cognome"
                            rules="required"
                            >
                            <b-form-input
                                v-model="campiform.lead.surname"
                                :state="errors.length > 0 ? false:null"
                                placeholder="" 
                                @input="aggiornaRappresentante"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col md="4" lg="3">
                        <b-form-group label="Email *" label-for="email">
                            <validation-provider
                            #default="{ errors }"
                            name="Email dell'utente"
                            rules="required|email"
                            >
                            <b-form-input
                                v-model="campiform.lead.email"
                                :state="errors.length > 0 ? false:null"
                                placeholder=""
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Cellulare" label-for="Cellulare">
                            <b-form-input
                                v-model="campiform.lead.mobile_phone"
                                placeholder=""
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Telefono" label-for="telefono">
                            <b-form-input
                                v-model="campiform.lead.phone"
                                placeholder=""
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Reseller" label-for="reseller_id">
                            <b-form-select
                                v-model="campiform.lead.reseller_id"
                                :options="options_user_reseller"
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Assistente" label-for="assistant_id">
                            <b-form-select
                                v-model="campiform.lead.assistant_id"
                                :options="options_user_assistente"
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Valutazione *" label-for="evaluation_id">
                          <validation-provider
                          #default="{ errors }"
                          name="Valutazione"
                          rules="required"
                          >
                          <b-form-select
                            v-model="campiform.lead.evaluation_id"
                            :options="options_evalution"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Rating" label-for="rating">
                            <b-form-select
                                v-model="campiform.lead.rating"
                                :options="options_rating"
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Stato *" label-for="status_id">
                            <validation-provider
                            #default="{ errors }"
                            name="Ruolo"
                            rules="required"
                            >
                            <b-form-select
                                v-model="campiform.lead.status_id"
                                :options="options_status"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Iscritto newsletter *" label-for="newsletter">
                            <b-form-select
                                v-model="campiform.lead.newsletter"
                                :options="options_newsletter"
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group label="Origine *" label-for="source_id">
                            <validation-provider
                            #default="{ errors }"
                            name="Origine"
                            rules="required"
                            >
                            <b-form-select
                                v-model="campiform.lead.source_id"
                                :options="options_source"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group label="Sito web" label-for="website">
                            <b-form-input
                                v-model="campiform.lead.website"
                                placeholder=""
                            />
                        </b-form-group>
                      </b-col>
                    </b-row>

                  </b-card>
                </b-tab>

              
                <b-tab>
                  <template #title>
                    <feather-icon
                      icon="LockIcon"
                      size="16"
                      class="mr-0 mr-lg-50"
                    />
                    <span class="d-none d-lg-inline">Fatturazione</span>
                  </template>
                  <b-card bg-variant="Default">
                    <b-row>
                      <b-col md="4" lg="3">
                        <b-form-group label="Nazione" label-for="country_id">
                          <vue-autosuggest
                            ref="autocomplete"
                            v-model="valoreDefaultNazione"
                            :suggestions="filteredOptions"
                            :limit="8"
                            :input-props="{id:'autosuggest__input',class:'form-control', placeholder:'cerca nazione', }"
                            :render-suggestion="renderSuggestion"
                            :get-suggestion-value="getSuggestionValue"
                            @input="onInputChange"
                            @selected="selectHandler"
                          >
                            <template slot-scope="{suggestion}">
                              <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
                            </template>
                          </vue-autosuggest>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Indirizzo" label-for="address">
                          <validation-provider
                          #default="{ errors }"
                          name="Indirizzo"
                          rules="min:2"
                          >
                            <b-form-input
                                v-model="campiform.billing.address"
                                placeholder=""
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Cap" label-for="zip">
                          <validation-provider
                          #default="{ errors }"
                          name="Cap"
                          :rules="lunghezza_campo_cap"
                          >
                          <b-form-input
                              v-model="campiform.billing.zip"
                              :state="errors.length > 0 ? false:null"
                              placeholder=""
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Città" label-for="city">
                          <validation-provider
                          #default="{ errors }"
                          name="Città"
                          rules="min:2"
                          >
                            <b-form-input
                                v-model="campiform.billing.city"
                                placeholder=""
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <div v-if="campiform.billing.province_id == 112">
                          <b-form-group label="Provincia *" label-for="province_foreign">
                            <b-form-input
                                v-model="campiform.billing.province_foreign"
                                placeholder=""
                                rules="min:2"
                            />
                          </b-form-group>
                        </div>
                        <div v-else>
                          <b-form-group label="Provincia *" label-for="province_id">
                            <b-form-select
                                v-model="campiform.billing.province_id"
                                :options="options_province"
                            />
                          </b-form-group>
                        </div>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Partita IVA" label-for="vat_number">
                          <validation-provider
                          #default="{ errors }"
                          name="Partita IVA"
                          rules="regex:^([a-zA-Z0-9]+)$|min:5"
                          >
                            <b-form-input
                              v-model="campiform.billing.vat_number"
                              :state="errors.length > 0 ? false:null"
                              placeholder=""
                            />
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Codice fiscale" label-for="fiscal_code">
                          <b-form-input
                            v-model="campiform.billing.fiscal_code"
                            placeholder=""
                            :readonly="isReadOnly_fiscal_code"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Pec" label-for="pec">
                          <b-form-input
                            v-model="campiform.billing.pec"
                            placeholder=""
                            :readonly="isReadOnly_pec"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Codice SDI" label-for="dest_code">
                          <validation-provider
                          #default="{ errors }"
                          name="Codice SDI"
                          rules="length:7"
                          >
                            <b-form-input
                              v-model="campiform.billing.dest_code"
                              :state="errors.length > 0 ? false:null"
                              placeholder=""
                              :readonly="isReadOnly_dest_code"
                            />
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Regime IVA" label-for="vat_scheme_id">
                          <b-form-select
                            v-model="campiform.billing.vat_scheme_id"
                            :options="options_regine_iva"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="8" lg="6">
                        <b-form-group
                          label="Pagamenti"
                          label-for="v-adse-pagamenti"
                        >
                          <multiselect
                            v-model="campiform.payment.list"
                            :options="options_payment"
                            :custom-label="multiSelect_act_Lingua" 
                            placeholder="seleziona o ricerca"
                            :multiple="true"
                            :close-on-select="false" 
                            :clear-on-select="false"
                            :preserve-search="true"
                            :show-labels="false"
                            :max-height="250"
                            :max="5"
                            label="pagamenti" 
                            track-by="text" 
                          >
                            <span slot="noResult">Nessun risultato</span>
                            <span slot="maxElements">Limite opzioni selezionabili raggiunto</span>
                          </multiselect>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" lg="3">
                        <b-form-group label="Split Payment" label-for="split_payment">
                            <b-form-select
                                v-model="campiform.billing.split_payment"
                                :options="options_split_payment"
                            />
                        </b-form-group>
                      </b-col>
                      <b-col md="8" lg="6">
                        <label for="textarea-note">Note XML</label>
                          <b-form-input
                            v-model="campiform.billing.note_xml"
                            placeholder=""
                          />
                      </b-col>
                      <b-col md="8" lg="3">
                        <label for="rappresentante-legale">Rappresentante legale</label>
                          <b-form-input
                            v-model="campiform.billing.legal_representative"
                            placeholder=""
                          />
                      </b-col>
                    </b-row>
                  </b-card>
                </b-tab>
              </b-tabs>

              <b-row>
                  <b-col md="12" class="text-center mb-3">
                    <b-button
                      variant="outline-primary"
                      type="submit"
                      :disabled="action_press"
                      @click.prevent="validationForm()"
                    >
                      <div v-if="action_press">Salvaggio in corso <b-spinner small class="ml-1" /></div>
                      <div v-else>Salva</div> 
                    </b-button>
                  </b-col>
              </b-row>
              
            </b-form>
      </validation-observer>
    </div>

    <b-modal
      ref="openapi-checkpiva"
      size="lg"
      centered
      hide-footer
      title="Verificare P.Iva"
      @hide="resetOpenapicheckpiva"
    >
      <div v-if="bottone_rimandare_scheda_cliente">
        <p>La partita iva inserita è già associata al cliente <strong>{{ this.dati_controllo_piva.ricerca.company_name }}</strong></p>
        <p>
          <b-button
            variant="primary"
            @click="$router.push({ name: 'crm-customers-show', params: { id_riga: dati_controllo_piva.ricerca.userable_id }})"
          >
            <feather-icon icon="EyeIcon" /> Visualizza Cliente
          </b-button>
        </p>
      </div>
      <div v-if="bottone_ripristino_scheda_cliente">
        <p>La partita iva inserita è già associata al cliente <strong>{{ this.dati_controllo_piva.ricerca.company_name }}</strong></p>
        <p>
          <b-button
            variant="primary"
            @click="ripristinaClienteDaSoftDelete(dati_controllo_piva.ricerca.userable_id)"
          >
            <feather-icon icon="RefreshCcwIcon" /> Ripristina Cliente
          </b-button>
        </p>
      </div>

    </b-modal>
      
  </div>
</template>

<script>
import router from '@/router'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import it from 'vee-validate/dist/locale/it.json'
import { BTabs, BTab, BRow, BCol, BCard, BCardText, BSpinner, BButton, BFormGroup, BForm, BInputGroup, BFormInput, BFormTextarea, BInputGroupPrepend, BInputGroupAppend, BDropdownDivider, BFormSelect } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  required, email, digits, alphaDash, length, min
} from '@validations'
import { VueAutosuggest } from 'vue-autosuggest'
import Multiselect from 'vue-multiselect' 

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    it,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard, 
    BCardText, 
    BSpinner, 
    BButton, 
    BForm,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormTextarea, 
    BInputGroupPrepend,
    BInputGroupAppend,
    BDropdownDivider,
    BFormSelect,

    VueAutosuggest,
    Multiselect, 

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,     
  },
  data() {
    return {
      id_italina: '114',
      valoreDefaultNazione: "",
      isReadOnly_fiscal_code: false, 
      isReadOnly_pec: false, 
      isReadOnly_dest_code: false, 
      lunghezza_campo_cap: 'digits:5', 
      campiform: {
        lead: {
          id: '',
          email: '', 
          name: '', 
          surname: '',
          mobile_phone: '',
          phone: '', 
          reseller_id: '',
          assistant_id: '',
          evaluation_id: '',
          rating: 3,
          source_id: [],
          website: '',
          status_id: [],
          newsletter: '',
        },
        billing: {
          country_id: '',
          province_id: '',
          province_foreign: '',
          address: '',
          zip: '',
          city: '',
          company_name: '',
          vat_number: '',
          fiscal_code: '',
          pec: '',
          dest_code: '',
          vat_scheme_id: null,
          note_xml: '', 
          split_payment: '',
          legal_representative: ''
        },
        payment: { 
          list : [ ],
        }
      },
      options_rating: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ],
      options_newsletter: [
        { value: 'Si', text: 'Si' },
        { value: 'No', text: 'No' },
        { value: 'Bounce', text: 'Bounce', disabled: true }
      ],
      options_split_payment: [
        { value: 'Si', text: 'Si' },
        { value: 'No', text: 'No' },
      ],
      required,
      email,
      alphaDash, 
      digits,
      length,
      min,
      options_user_reseller: [ ],
      options_user_assistente: [ ],
      options_evalution: [ ],
      options_status: [ ],
      options_source: [ ], 
      options_payment: [ ], 
      options: [ ],
      options_province: [ ],
      options_regine_iva: [ ],

      Caricato: false,
      errore_caricamento: false,
      submitted: false,
      action_press: false,

      filteredOptions: [],
      limit: 10, 

      controllo_piva_presente: false,
      bottone_rimandare_scheda_cliente: false,
      bottone_ripristino_scheda_cliente: false,
      dati_controllo_piva: {},
    }
  },
  created() {
    //errori validazione in italiano
    localize({
      it: {
        messages: it.messages,
      },
    })   

    const leadquattro = this.$http.get('api/fs/leadquattro/list')
    const infoLeadPromise = this.$http.get('api/crm/lead/card/'+router.currentRoute.params.id_riga)

    Promise.all([leadquattro, infoLeadPromise]).then(response => {
      if(response[0].data.statusCode===200){
        //caricamento lista nazioni
        this.options = response[0].data.reply.country
        //caricamento lista province italiane
        this.options_province = response[0].data.reply.province
        //caricamento lista utenti employee assistenti
        let i = 0;
        const assistenti = response[0].data.reply.crm_assistenti;
        const numeroAssistenti = assistenti.length;

          while (i < numeroAssistenti) {
            this.options_user_assistente[i] = { value: response[0].data.reply.crm_assistenti[i].id, text: response[0].data.reply.crm_assistenti[i].name+' '+response[0].data.reply.crm_assistenti[i].surname },
            
            i++;
          }

        //caricamento lista utenti employee reseller
        let u = 0;
        const reseller = response[0].data.reply.crm_reseller;
        const numeroReseller = reseller.length;

          while (u < numeroReseller) {
            this.options_user_reseller[u] = { value: response[0].data.reply.crm_reseller[u].id, text: response[0].data.reply.crm_reseller[u].name+' '+response[0].data.reply.crm_reseller[u].surname },
            
            u++;
          }

        //caricamento lista evaluation
        this.options_evalution = response[0].data.reply.evaluation
        //caricamento lista status
        this.options_status = response[0].data.reply.status
        //caricamento lista source
        this.options_source = response[0].data.reply.source
        //caricamento lista regime iva
        this.options_regine_iva = response[0].data.reply.vatschema
        //caricamnto lista pagamenti
        this.options_payment = response[0].data.reply.payment

        if(response[1].data.statusCode===200){
          //caricamento dati lead
          this.campiform.lead = response[1].data.reply.leadData

          //collimazione dati strutturati lead
          this.campiform.lead.status_id = response[1].data.reply.leadData.status.value
          this.campiform.lead.source_id = response[1].data.reply.leadData.source.value

          this.campiform.payment.list = response[1].data.reply.leadData.payment.map(item => {
            return {
              value: item.id,
              text: item.name
            };
          });

          //estrazione billing (sicrono)
          if(this.campiform.lead.has_billing === true){
            this.$http.get('api/crm/billing/lead/card/'+this.campiform.lead.id).then(response_billing => {
              if((response_billing.data.statusCode>=200) && (response_billing.data.statusCode<=299)){
                //risposta positiva
                this.campiform.billing = response_billing.data.reply.billingData

                //valore default per campo Nazione con autosuggest
                var id_nazione = this.campiform.billing.country_id
                var nazione = this.options.filter(function(elem){
                    if(elem.value == id_nazione){
                    return elem.text
                    }
                })
                this.valoreDefaultNazione = nazione[0].text

                if(id_nazione != 114){
                  //stato estero
                  this.isReadOnly_fiscal_code = true;
                  this.isReadOnly_dest_code = true;
                  this.isReadOnly_pec = true;
                  this.lunghezza_campo_cap = 'min:2';
                } else {
                  this.isReadOnly_fiscal_code = false;
                  this.isReadOnly_dest_code = false;
                  this.isReadOnly_pec = false;
                  this.lunghezza_campo_cap = 'digits:5';
                }
                
                this.Caricato = true;
                this.errore_caricamento = false;
              } else {
                //risposta negativa (errore sul server)
                
                this.Caricato = false;
                this.errore_caricamento = true;
              }
            }).catch(e => {
              console.log(e);
            });
        
          } else {
            this.Caricato = true;
            this.errore_caricamento = false;
          }
            
        } else {
          this.Caricato = false;
          this.errore_caricamento = true;
        }
      } else {
        this.Caricato = false;
        this.errore_caricamento = true;
      }
    })    
  },
  methods: {
    aggiornaRappresentante() {
      console.log("aggiornaRappresentante")
      if ((this.campiform.billing.legal_representativee == "") || (this.campiform.billing.legal_representative == null)) {
        console.log("aggiornaRappresentante -> null -> "+this.campiform.lead.surname)
        this.campiform.billing.legal_representative = this.campiform.lead.surname+" - pippo - "+this.campiform.lead.name;
      }
    },
    onInputChange(testo_ricerca) {
      if (testo_ricerca === '' || testo_ricerca === undefined) {
        return
      }

      //filtra array nazioni
      const filteredData = this.options.filter(item => item.text.toLowerCase().indexOf(testo_ricerca.toLowerCase()) == 0).slice(0, this.limit)
      
      this.filteredOptions = [{
        data: filteredData,
      }]
    },
    renderSuggestion(suggestion) {
      //per gestire le voci restituite nella finestra auto-suggest
      return suggestion.item.text;
    },
    getSuggestionValue(suggestion) {
      //per gestire il testo che verra visualizzato dopo la selezione dela voce dalla finestra dell'auto-suggest
      return suggestion.item.text;
    },
    selectHandler(text){
      if (text === '' || text === undefined) {
        return
      } else {
        //associo id_nazione al parametro da passare all'api
        this.campiform.billing.country_id = text.item.value

        if(this.campiform.billing.country_id == this.id_italina){
          //lascio quello che già c'è (perchè nell'insert di defualt se non seleziono nulla, carico provincia = Nessuna)
          //Codice fiscale
          this.isReadOnly_fiscal_code = false;
          //codice SDI
          this.isReadOnly_dest_code = false;
          //Pec
          this.isReadOnly_pec = false;
          //lunghezza CAP (per validazione)
          this.lunghezza_campo_cap = 'digits:5';
        } else {
          //province_id estera
          this.campiform.billing.province_id = '112';
          //Codice fiscale
          this.isReadOnly_fiscal_code = true;
          this.campiform.billing.fiscal_code = ' '; //svuoto per sicurezza il campo
          //codice SDI
          this.campiform.billing.dest_code = '0000000';
          this.isReadOnly_dest_code = true;
          //Regime IVA
          this.campiform.billing.vat_scheme_id = '2'; //non soggetto
          //Pec
          this.isReadOnly_pec = true;
          this.campiform.billing.pec = ' '; //svuoto per sicurezza il campo
          //lunghezza CAP (per validazione)
          this.lunghezza_campo_cap = 'min:2';
        }
      }
    },
    multiSelect_act_Lingua ({ value, text }) {
      return `${text}`
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          //console.log(this.campiform)
          this.action_press = true

          this.$http.post('api/crm/lead/card/'+this.campiform.lead.id, 
            this.campiform.lead 
            ).then(response => { 
              //console.log(response.data)
              //console.log("statusCode -> "+response.data.statusCode)

              if((response.data.statusCode>=200) && (response.data.statusCode<=299)){
                //risposta positiva
                if(response.data.reply.leadData.id > 0){

                  //procedo al controllo della p.iva
                  if((this.campiform.billing.vat_number != '') && (this.campiform.billing.vat_number !==  null)){                    
                      this.$http.post('api/crm/billing/check_duplicate_vat', {
                        vat_number: this.campiform.billing.vat_number, 
                        id_billing: this.campiform.billing.id
                      }).then(response_vat_check => {
                        if((response_vat_check.data.statusCode>=200) && (response_vat_check.data.statusCode<=299)){
                          //console.log("risposta controllo P.iva ------------------")
                          //console.log(response_vat_check)

                          if(response_vat_check.data.reply.data.duplicato == 'si'){
                            if(response_vat_check.data.reply.data.ricerca.tipo_scheda == 'cliente'){
                              //Risposta dal controllo della P.Iva già presente su un cliente
                              this.controllo_piva_presente = true;
                              this.dati_controllo_piva = response_vat_check.data.reply.data;

                              if(response_vat_check.data.reply.data.controllo_clienti_deleted_at	=== null){
                                //solo bottone per rimandare a scheda cliente
                                this.bottone_rimandare_scheda_cliente = true;
                                this.bottone_ripristino_scheda_cliente = false;
                              } else {
                                //bottone per ripristino cliente e poi rimandare a scheda cliente
                                this.bottone_rimandare_scheda_cliente = false;
                                this.bottone_ripristino_scheda_cliente = true;
                              }                              

                              this.openModalCheckPiva();

                            } else {
                              //duplicato Lead o sconosciuto con la stessa P.Iva inserita nel form
                              // => niente salvataggio dati billing per evitare errori di integrità del DB (tanto comunque nel DB non salverebbero per invia del vat_number univoco)

                              //redirect con messaggio specifico
                              this.$router.replace('/crm/leads')
                              .then(() => {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Nuovo lead creato correttamente',
                                    text: 'I dati di fatturazione sono già presenti nella scheda '+response_vat_check.data.reply.data.ricerca.tipo_scheda+' di '+response_vat_check.data.reply.data.ricerca.company_name,
                                    confirmButtonText: 'chiudi',
                                    customClass: {
                                    confirmButton: 'btn btn-success',
                                    },
                                })
                              })
                            }

                          } else {
                            //nessun duplicato => procedo con la normale procedura di salvataggio dei dati di Billings
                            //procediamo al salvataggio del Billing SOLO se ci sono i campi "ragione sociale" compilato
                            if(
                              (this.campiform.billing.company_name != '')
                            ){ 

                              //OK -> procedo al salvataggio dati "billing"
                              this.$http.post('api/crm/billing/lead/card/'+response.data.reply.leadData.id , 
                              this.campiform.billing
                              ).then(response_billing => {
                                if((response_billing.data.statusCode>=200) && (response_billing.data.statusCode<=299)){
                                  //risposta positiva

                                  //ok -> procedo al salvataggio dei valori del Payment
                                  this.$http.post('api/crm/lead/savepaymentsedit/'+response.data.reply.leadData.id, 
                                    this.campiform.payment
                                  ).then(response_payment => {
                                    if((response_payment.data.statusCode>=200) && (response_payment.data.statusCode<=299)){
                                      //risposta positiva
                                      this.$router.replace('/crm/leads')
                                        .then(() => {
                                          this.$swal({
                                              icon: 'success',
                                              title: 'Lead aggiornato correttamente',
                                              confirmButtonText: 'chiudi',
                                              customClass: {
                                              confirmButton: 'btn btn-success',
                                              },
                                          })
                                        })
                                    
                                    } else {
                                      //risposta negativa (errore sul server)
                                      this.$swal({
                                          icon: 'error',
                                          title: 'Si è verificato un errore in Lead_Payments',
                                          text: 'Errore: A03 - '+response_payment.data.reply.message,
                                          customClass: {
                                          confirmButton: 'btn btn-outline-primary',
                                          },
                                      })

                                      this.action_press = false
                                    }
                                  }).catch(e => {
                                    console.log(e);
                                  });
                                
                                } else {
                                  //risposta negativa (errore sul server)
                                  this.$swal({
                                      icon: 'error',
                                      title: 'Si è verificato un errore in Billing',
                                      text: 'Errore: B01 - '+response_billing.data.reply.message,
                                      customClass: {
                                      confirmButton: 'btn btn-outline-primary',
                                      },
                                  })
                                    
                                  this.action_press = false
                                }
                              }).catch(e => {
                                console.log(e);
                              });

                            } else {
                              //non ci sono dati Billing da salvare ... FINE
                              this.$router.replace('/crm/leads')
                                .then(() => {
                                  this.$swal({
                                      icon: 'success',
                                      title: 'Lead aggiornato correttamente',
                                      confirmButtonText: 'chiudi',
                                      customClass: {
                                      confirmButton: 'btn btn-success',
                                      },
                                  })
                                })
                            }
                          }

                        } else {
                          //risposta negativa (errore sul server)
                          this.$swal({
                              icon: 'error',
                              title: 'Si è verificato un errore durante il controllo della P.Iva',
                              text: response_vat_check.data.reply.message,
                              customClass: {
                              confirmButton: 'btn btn-outline-primary',
                              },
                          })

                        }
                      }).catch(e => {
                        console.log(e);
                      });

                  } else {
                    //niente P.Iva inserita (può essere anche null)
                    //procediamo al salvataggio del Billing SOLO se ci sono i campi "ragione sociale" e "partita iva" compilati
                    if(
                      (this.campiform.billing.company_name != '')
                    ){                  
                      //OK -> procedo al salvataggio dati "billing"
                      this.$http.post('api/crm/billing/lead/card/'+response.data.reply.leadData.id , 
                      this.campiform.billing
                      ).then(response_billing => {
                        if((response_billing.data.statusCode>=200) && (response_billing.data.statusCode<=299)){
                          //risposta positiva
                          this.$router.replace('/crm/leads')
                          .then(() => {
                              this.$swal({
                                  icon: 'success',
                                  title: 'Lead aggiornato correttamente',
                                  confirmButtonText: 'chiudi',
                                  customClass: {
                                  confirmButton: 'btn btn-success',
                                  },
                              })
                          })
                        
                        } else {
                          //risposta negativa (errore sul server)
                          this.$swal({
                              icon: 'error',
                              title: 'Si è verificato un errore in Billing',
                              text: 'Errore: B02 - '+response_billing.data.reply.message,
                              customClass: {
                              confirmButton: 'btn btn-outline-primary',
                              },
                          })
                            
                          this.action_press = false
                        }
                      }).catch(e => {
                        console.log(e);
                      });
                    } else {
                      //non ci sono dati Billing da salvare ... FINE
                      this.$router.replace('/crm/leads')
                        .then(() => {
                          this.$swal({
                              icon: 'success',
                              title: 'Lead aggiornato correttamente',
                              confirmButtonText: 'chiudi',
                              customClass: {
                              confirmButton: 'btn btn-success',
                              },
                          })
                        })
                    }
                  }
                } else {
                  //questo non dovrebbe mai accadere ... ma non si sa mai -> visualizzo risposta ma non faccio redirect
                  this.$swal({
                      icon: 'warning',
                      title: 'Si è verificato un errore Lead',
                      text: 'Salvataggio riuscito ma con errore '+response.data.statusCode+', ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                        
                  this.action_press = false
                }
                
              } else {
                //risposta negativa (errore sul server)
                if(response.data.reply.message != ''){
                  this.$swal({
                      icon: 'warning',
                      title: 'Si è verificato un errore',
                      text: response.data.reply.message,
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                } else {
                  this.$swal({
                      icon: 'error',
                      title: 'Si è verificato un errore generico',
                      text: 'operazione non riuscita, ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                }

                this.action_press = false
              }
            }).catch(e => {
              console.log(e);
            });

        }
      })
    },
    openModalCheckPiva(){
      //console.log("openModalCheckPiva ---------------")
      //console.log(this.dati_controllo_piva)

      this.$refs['openapi-checkpiva'].show()
    },
    resetOpenapicheckpiva(){
      this.action_press = false
    },
    ripristinaClienteDaSoftDelete(userable_id){
      //console.log("ripristinaClienteDaSoftDelete -> " + userable_id);

      this.$http.post('api/crm/customer/ricovery/' + userable_id).then(response => { 
          //console.log("risposta server 'ricovery' --------")
          //console.log(response.data)

          if((response.data.statusCode>=200) && (response.data.statusCode<=299)){
            //risposta positiva
            
            //redirect con messaggio specifico
            this.$router.replace('/crm/customers/show/' + userable_id)
            .then(() => {
              this.$swal({
                  icon: 'success',
                  title: 'Cliente ripristinato correttamente',
                  confirmButtonText: 'chiudi',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
              })
            })
            
          } else {
            //risposta negativa (errore sul server)
            this.$swal({
                icon: 'error',
                title: 'Si è verificato un errore',
                text: response.data.reply.message,
                customClass: {
                confirmButton: 'btn btn-outline-primary',
                },
            })

            this.action_press_openApiRicercaPerRagioneSociale = false;
          }
        }).catch(e => {
          console.log(e);
        });
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-multiselect.min.scss';
</style>
